import { scrollSmootherInstance } from "../globals/gsap";
import { throttle } from "lodash";

class Overlay {
  constructor($el) {
    this.$el = $el;
    this.$closeTrigger = $el.find('[data-overlay="close"]');
    this.$backdrop = $el.find('[data-overlay="backdrop"]');
    this.$container = $el.find('[data-overlay="container"]');
    this.isOpen = false;

    this.init();
  }

  init = () => {
    this.$closeTrigger.on('click', this.close);
    this.$backdrop.on('click', this.close);

    window.addEventListener('resize', throttle(this.resizeHandler, 250));
  }

  open = (preselectId = null) => {
    if (preselectId) {
      this.preselect(preselectId);
    }
    // set top postion on this.$el
    this.$container.css('top', scrollSmootherInstance.scrollTop());
    scrollSmootherInstance.paused(true);

    this.$el.addClass('overlay--open');
    this.isOpen = true;

    window.addEventListener('keydown', this.escapeKeyHandler);
  }

  close = () => {
    scrollSmootherInstance.paused(false);

    this.$el.removeClass('overlay--open');
    this.isOpen = false;

    window.removeEventListener('keydown', this.escapeKeyHandler);
  }

  preselect = (id) => {
    const $option = this.$el.find(`[data-preselect="${id}"]`);
    if($option.length) {
      $option.prop('selected', true);
    }
  }

  escapeKeyHandler = (e) => {
    if (e.key === 'Escape') {
      this.close();
    }
  }

  resizeHandler = () => {
    if(this.isOpen) {
      this.$container.css('top', scrollSmootherInstance.scrollTop());
    }
  }
}

export default Overlay;